import React, { Component } from 'react';
import { Grid, Col, ButtonToolbar, Breadcrumb, Tabs, Tab } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../Layout/ContentWrapper';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import MobileManagementTable from './MobileManagementTable';
import BillboardImagesTable from './BillboardImagesTable';
import RichTextEditor from '../Common/RichTextEditor';
import SpinnerButton from '../Common/SpinnerButton';
import {
  saveFAQBoxText,
  fetchFAQBoxText,
} from '../../actions/mobileManagement_actions';
import { companyCodeTitle } from '../../actions/root_url';

const createDialogStyle = {
  width: '800px',
  height: '800px',
  marginLeft: '-15%',
  top: '30%',
};

class MobileManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestValue: '',
      productSearchType: 'ProductNum',
      selectedProduct: null,
      productList: [],
      tabKey: 1,
      isFAQBoxOpen: false,
      faqRichText: undefined,
      isLoadingFAQSave: false,
      saveFAQRichTextSuccess: false,
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    // this.props.fetchGreatDealsNewArrivals();
    this.props.fetchBillboardImages();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.productList !== nextProps.productList) {
      this.setState({ productList: nextProps.productList });
    }
  }

  onSuggestionSelected = (productNum, suggestions) => {
    this.setState({ selectedProduct: suggestions }, this.addProductToTable);
  }

  addProductToTable = () => {
    this.setState((prevState) => {
      const { productList, selectedProduct } = prevState;
      const index = _.findIndex(productList, { Product_id: selectedProduct.Product_id });
      if (index === -1) {
        productList.push(selectedProduct);
      } else {
        alert('Product is already in the list');
      }
      return { productList, selectedProduct: null, suggestValue: '' };
    });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  handleSelect = (tabKey) => {
    this.setState({ tabKey });
  }

  openFAQBox = () => {
    this.setState({ isFAQBoxOpen: true });
  }

  closeFAQBox = () => {
    this.setState({ isFAQBoxOpen: false });
  }

  saveRichText = (htmlText) => {
    const handleSuccess = () => {
      this.setState({
        isLoadingFAQSave: false,
        saveFAQRichTextSuccess: true,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        isLoadingFAQSave: false,
        saveFAQRichTextSuccess: false,
      });
    };
    this.setState({
      isLoadingFAQSave: true,
      saveFAQRichTextSuccess: false,
    }, () => saveFAQBoxText(htmlText, handleSuccess, handleFailure));
  }

  fetchRichText = () => {
    const handleSuccess = (response) => {
      this.setState({
        faqRichText: response.rich_text,
        isLoadingFAQRichText: false,
      }, () => this.openFAQBox());
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        faqRichText: '',
        isLoadingFAQRichText: false,
      }, () => this.openFAQBox());
    };
    this.setState({
      isLoadingFAQRichText: true,
    }, () => fetchFAQBoxText(handleSuccess, handleFailure));
  }

  renderAutoSuggest() {
    return (
      <div className="control-dropdown">
        <GenericProductSuggest
          value={this.state.suggestValue}
          onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
          SearchType={this.state.productSearchType}
          fetchOrdersByProduct={this.onSuggestionSelected}
        />
      </div>
    );
  }

  renderBillboardImagesTable() {
    const {
      billboardImagesList,
      billboardImagesIsLoading,
      saveBillboardImages,
      savingBillboardImages,
      fetchBillboardImages,
      deleteBillboardImage,
      deletingBillboardImage,
    } = this.props;
    return (
      <BillboardImagesTable
        rows={billboardImagesList}
        rowsIsLoading={billboardImagesIsLoading}
        saveBillboardImages={saveBillboardImages}
        saving={savingBillboardImages}
        reload={fetchBillboardImages}
        delete={deleteBillboardImage}
        deleting={deletingBillboardImage}
      />
    );
  }

  renderGreatDealsTable() {
    const { productList } = this.state;
    const {
      productListIsLoading,
      updateGreatDeals,
      updateNewArrivals,
      isUpdating,
    } = this.props;
    return (
      <MobileManagementTable
        // title={<Translate value="great_deals/new_arrivals" />}
        rows={productList}
        rowsIsLoading={productListIsLoading}
        saveProducts={{
          saveGreatDeals: updateGreatDeals,
          saveNewArrivals: updateNewArrivals,
        }}
        isUpdating={isUpdating}
      />
    );
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <Translate value="mobile_management" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar id="breadcrumbButtonGroup">
          <SpinnerButton
            bsStyle="primary"
            onClick={this.fetchRichText}
            disabled={this.state.isLoadingFAQRichText}
            loading={this.state.isLoadingFAQRichText}
            icon="fa-pencil"
            translation={<Translate value="faq" />}
          />
        </ButtonToolbar>
        <Grid id="mobile-management">
          <Col xs={10} xsOffset={1}>
            <Tabs activeKey={this.state.tabKey} justified onSelect={this.handleSelect}>
              {/* <Tab eventKey={1} title={<Translate value="great_deals/new_arrivals" />}>
                <Col>
                  <Panel id="search-panel">
                    <Col xs={12} className="search-panel-left">
                      <div id="autosuggest-div">
                        <Row style={{ height: '30px' }}>
                          <Col xs={12}>
                            <TypeRadios
                              value={this.state.productSearchType}
                              handleOptionChange={this.handleOptionChange}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            { this.renderAutoSuggest() }
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Panel>
                </Col>
                <Col>
                  { this.renderGreatDealsTable() }
                </Col>
              </Tab> */}
              <Tab eventKey={1} title={<Translate value="billboard_images" />}>
                <Col>
                  { this.renderBillboardImagesTable() }
                </Col>
              </Tab>
            </Tabs>
          </Col>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.isFAQBoxOpen}
            onCloseClicked={this.closeFAQBox}
            title={<Translate value="faq" />}
          >
            <RichTextEditor
              htmlString={this.state.faqRichText}
              placeholder="Enter the frequently asked questions."
              saveHtml={(richText) => { this.saveRichText(richText); }}
              isLoadingSave={this.state.isLoadingFAQSave}
              saveSuccess={this.state.saveFAQRichTextSuccess}
            />
          </SkyLightStateless>
        </Grid>
      </ContentWrapper>
    );
  }
}

MobileManagement.defaultProps = {
  isUpdating: false,
  isUpdated: false,
  productList: [],
  productListIsLoading: false,
  billboardImagesList: [],
  billboardImagesIsLoading: false,
  savingBillboardImages: false,
  deletingBillboardImage: false,
};

MobileManagement.propTypes = {
  fetchGreatDealsNewArrivals: PropTypes.func.isRequired,
  fetchBillboardImages: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool,
  isUpdated: PropTypes.bool,
  productList: PropTypes.array,
  productListIsLoading: PropTypes.bool,
  updateGreatDeals: PropTypes.func.isRequired,
  updateNewArrivals: PropTypes.func.isRequired,
  billboardImagesList: PropTypes.array,
  billboardImagesIsLoading: PropTypes.bool,
  saveBillboardImages: PropTypes.func.isRequired,
  savingBillboardImages: PropTypes.bool,
  deleteBillboardImage: PropTypes.func.isRequired,
  deletingBillboardImage: PropTypes.bool,
};

export default MobileManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/General/MobileManagement.jsx